import axios from "../axios-auth";
import orginal_axios from "axios";

export const procurementPlanReportService = {
  getProcurementPlanReport,
  procurementPlanReportExcel,
};

function getProcurementPlanReport(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }

  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy,
  };

  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.categoryName) {
    params["categoryName"] = searchParams.categoryName;
  }
  if (searchParams.brandName) {
    params["brandName"] = searchParams.brandName;
  }
  if (searchParams.productIds) {
    params["productIds"] = searchParams.productIds.join();
  }

  return axios.get("/auth/procurement-plan-reports", { params });
}

function procurementPlanReportExcel(searchParams) {
  let params = {
    sort: "p.name,asc",
  };
  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.categoryName) {
    params["categoryName"] = searchParams.categoryName;
  }
  if (searchParams.brandName) {
    params["brandName"] = searchParams.brandName;
  }
  if (searchParams.productIds) {
    params["productIds"] = searchParams.productIds.join();
  }

  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/procurement-plan-report-excel",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
  }).then(function(response) {
    return {
      blob: new Blob([response.data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      headers: response.headers,
    };
  });
}
